import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CertificationService, Certification } from './certification.service';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class CertificationResolve extends CommonFiltersResolve implements Resolve<Certification[]> {

	constructor(private service: CertificationService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<Certification[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getCertification(filters)
			.then((certifications: Certification[]) => {
				this.mask.removeLoading();
				return certifications;
			});
	}
}
